import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=68626bdf"
import script from "./TheSidebar.vue?vue&type=script&lang=js"
export * from "./TheSidebar.vue?vue&type=script&lang=js"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=68626bdf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports